<template>
  <v-row >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="800px"
    >


      <template v-slot:activator="{ on, attrs }">
        <v-container>

        
        <v-row>
       <v-col cols="12" sm="12" lg="12" class="d-flex justify-end">
       <v-btn 
       v-bind="attrs"
          v-on="on"
          data-cy="add-usuario-input"
       @click="usuarioEdit" 
       text
       >
       <v-icon left>mdi-pencil</v-icon>
       Cambiar Seña
       </v-btn>

       </v-col>
        </v-row>
        </v-container>
       
      </template>



       <v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>


      <v-card>
        <v-card-title class="text-h5">
          Usuario  - Clave: {{usuarioData.id}}
        </v-card-title>
        
<v-card-text>
          <v-container>

              <!-- {{usuario}} -->
            <v-row>
              <v-col cols="12">
                

                <v-card-text>
               <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
   
   
    <v-text-field
           v-model="usuario.name"
           label="Nombre"
           disabled
         ></v-text-field>

         
   
        <v-text-field
                      v-model="usuario.passwordOld"
                      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min]"
                      :type="showPass ? 'text' : 'password'"
                      name="input-pass"
                      label="Contraseña Anterior"
                      hint="Minimo 5 caracteres"
                      counter
                      @click:append="showPass = !showPass"
                      data-cy="pass-input"
                    ></v-text-field>


                     <v-text-field
                      v-model="usuario.password"
                      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min]"
                      :type="showPass ? 'text' : 'password'"
                      name="input-pass"
                      label="Contraseña Nueva"
                      hint="Minimo 5 caracteres"
                      counter
                      @click:append="showPass = !showPass"
                      data-cy="pass-input"
                    ></v-text-field>


                     <v-text-field
                      v-model="usuario.passwordConfirm"
                      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min, matchPassword]"
                      :type="showPass ? 'text' : 'password'"
                      name="input-pass"
                      label="Repetir Contraseña"
                      hint="Minimo 5 caracteres"
                      counter
                      @click:append="showPass = !showPass"
                      data-cy="pass-input"
                    ></v-text-field>




    </v-form> 
            </v-card-text>
               


              </v-col>
              
            </v-row>
          </v-container>
        </v-card-text>


        - <v-card-actions>
           <v-spacer></v-spacer>
            <v-btn  outlined color="red darken-1"  text  @click="dialog = false">
               <v-icon>
       mdi-cancel
      </v-icon> 
              Cerrar ventana
            </v-btn>
            <v-btn outlined color="blue darken-4" 
            text @click="chagePass"
            data-cy="submit"
            >
            <v-icon>
       mdi-email-outline
      </v-icon> 
              Cambiar Seña
            </v-btn>
        </v-card-actions>  
      </v-card>




    </v-dialog>
  </v-row>
</template>




<script>


import router from "@/router/index";

import loginService from "@/services/loginService.js";

//import  {storage} from "../../firebase"
//import  {uploadBytes} from "firebase/storage"
//import {ref, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
//import  CloudImage  from '../CloudImage.vue'

 
export default {

   props: {
    usuarioData: {
      type: Object, // Tipo de dato correspondiente al objeto del autor
      default: () => ({}) // Valor por defecto, un objeto vacío si no se proporciona
    },

  },
 
 
  data: vm => ({
  //<td v-on:click="guardarUsuario(usuario)">{{usuario.name}}</td>
  valid: true,
    dialog:false,
 showPass: false,
    usuarios: [],
    buscador:'',

    mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: -1,
      },
      valid: false,
     
    usuario:{
id:'',
name:'',
email:'',
identificador:'',
passwordOld:'',
password:'',
passwordConfirm:''
        },
  
    rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                 
                },
    
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 1) || "Debe contener al menos 3 caracteres",
            ],
        
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ],
             numberRules: [
              (v) => (v >= 0) || "Valor debe ser mayor o igual a 0",
            ],
  }),
  components:{
     
  },
  mounted() {
    //this.listar();
    // console.log('Código del autor:', this.usuarioData);

     this.usuario=this.usuarioData;
  },
  methods: {
    matchPassword(value) {
      return value === this.usuario.password || 'Las contraseñas deben coincidir.';
    },

    usuarioEdit(){
      console.log(this.usuarioData);
      this.usuario=this.usuarioData;
    },
   
    chagePass(){

            if (this.$refs.form.validate()) {

                console.log("Formulario Validado");

    loginService.sendNewPass(this.usuario).then(
        response =>{
       
            console.log('success');

            console.log(response.data);


             this.mensaje.text="Contraseña cambiada correctamente, sera redirigido a la página de inicio de sesión";

             this.mensaje.color="primary";
      this.mensaje.colorBtn="blue";

      this.mensaje.snackbar="true";


loginService.logout().then(res=>{
       
            
              
        console.log("Token eliminado");

        localStorage.removeItem('token');

            localStorage.removeItem('identificador');


        }).catch(e=>{

          console.error(e.response.data.errors);

        })

      setTimeout(() => {
          this.usuario.password="";
          this.usuario.passwordOld="";
          this.usuario.passwordConfirm="";

   //    this.dialog=false;

 router.push("/login");
     this.dialog=false;
         
  
    }, 5000);

    


          
        }).catch((errors) =>{
        
           console.log('error '+errors.message);
            console.log(errors.response.data.message);

            

             let mensajeError = '';

          mensajeError += "\n"+"Error: "+errors.response.data.message;

            this.mensaje.text=mensajeError;

      this.mensaje.snackbar="true";

      this.mensaje.color="error";
      this.mensaje.colorBtn="error";
        
      

           
        })
      


            }


      //console.log(usuario);
       //     this.$emit('usuarioEdit',this.usuario);
       //     this.dialog=false;
        },
    validate(){
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
    ,
    limpiar(){

     
		this.usuario={
				id:'',
        name:'',
				email:'',
				identificador:'',
				password:''
	}}
  ,
    recibirUsuario:function(usuarioOpcion){

      console.log('En elemento padre Usuario');
        console.log(usuarioOpcion);
     

    }

  
  
  },//fin methos

    watch: {
      date (val) {
        
			
		
       
      },
    },




}
    
  
</script>